function InitNumberInput() {
    document.querySelectorAll('[data-number-input]').forEach(function(numberInput) {
        const addButton = numberInput.querySelector('[data-number-input__add]');
        const subButton = numberInput.querySelector('[data-number-input__sub]');
        const inputField = numberInput.querySelector('[data-number-input__display]');

        if(!!addButton) {
            addButton.onclick = () => {
                inputField.stepUp(1);
            }
        }

        if(!!subButton) {
            subButton.onclick = () => {
                inputField.stepDown(1);
            }
        }
    })
}

export default function () {
    InitNumberInput()
}
